import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import "./Slider.css";
import "../../../../Common/Common.css";
import "react-alice-carousel/lib/alice-carousel.css";
import Images1 from "../../../../../assets/img/imageSlider/4.jpg";
import Images2 from "../../../../../assets/img/imageSlider/4-1.png";
import Images3 from "../../../../../assets/img/imageSlider/5.jpg";
import Images4 from "../../../../../assets/img/imageSlider/6.jpg";
import Images5 from "../../../../../assets/img/imageSlider/slide-2-min.jpg";
import Images6 from "../../../../../assets/img/imageSlider/7.jpg";
import Images7 from "../../../../../assets/img/imageSlider/7-1.jpg";
import Images8 from "../../../../../assets/img/imageSlider/7-2.jpg";
import Images9 from "../../../../../assets/img/imageSlider/7-3.jpg";
import Images10 from "../../../../../assets/img/imageSlider/7-4.jpg";
import Images11 from "../../../../../assets/img/imageSlider/9.jpg";
import Images12 from "../../../../../assets/img/imageSlider/10.jpg";
import Images13 from "../../../../../assets/img/imageSlider/11.jpg";
import Images14 from "../../../../../assets/img/imageSlider/11-1.jpg";
import Images15 from "../../../../../assets/img/imageSlider/12.jpg";
import Images16 from "../../../../../assets/img/imageSlider/13.jpg";
import Images17 from "../../../../../assets/img/imageSlider/14.png";
import Images18 from "../../../../../assets/img/imageSlider/15.png";
import Images19 from "../../../../../assets/img/imageSlider/16.png";
import Images20 from "../../../../../assets/img/imageSlider/17.jpg";
import Images21 from "../../../../../assets/img/imageSlider/18.jpg";
import Images22 from "../../../../../assets/img/imageSlider/18-1.jpg";
import Images23 from "../../../../../assets/img/imageSlider/19.png";
import Images24 from "../../../../../assets/img/imageSlider/20.jpg";
import Images25 from "../../../../../assets/img/imageSlider/20-1.jpg";
import Images26 from "../../../../../assets/img/imageSlider/21.jpg";
import Images27 from "../../../../../assets/img/imageSlider/22.jpg";
import Images28 from "../../../../../assets/img/imageSlider/23.jpg";
import Images29 from "../../../../../assets/img/imageSlider/24.jpg";
import Images30 from "../../../../../assets/img/imageSlider/25.png";
import Images31 from "../../../../../assets/img/imageSlider/26.jpg";
import Images32 from "../../../../../assets/img/imageSlider/26-1.JPG";
import Images33 from "../../../../../assets/img/imageSlider/27.png";
import Images34 from "../../../../../assets/img/imageSlider/27-1.jpg";
import Images35 from "../../../../../assets/img/imageSlider/28.jpg";
import Images36 from "../../../../../assets/img/imageSlider/29.jpg";
import Images37 from "../../../../../assets/img/imageSlider/30.png";
import Images38 from "../../../../../assets/img/imageSlider/31.jpg";
import Images39 from "../../../../../assets/img/imageSlider/32.jpg";
import Images40 from "../../../../../assets/img/imageSlider/33.jpg";
import Images41 from "../../../../../assets/img/imageSlider/34.png";
import Images42 from "../../../../../assets/img/imageSlider/35.jpg";
import Images43 from "../../../../../assets/img/imageSlider/35-1.jpg";
import Images44 from "../../../../../assets/img/imageSlider/36.png";
import Images45 from "../../../../../assets/img/imageSlider/36-1.jpg";
import Images46 from "../../../../../assets/img/imageSlider/37-min.JPG";
import Images47 from "../../../../../assets/img/imageSlider/38-min.jpg";
import Images48 from "../../../../../assets/img/imageSlider/39-min.jpg";
import Images49 from "../../../../../assets/img/imageSlider/40-1-min.jpg";
import Images50 from "../../../../../assets/img/imageSlider/40-2-min.jpg";
import Images51 from "../../../../../assets/img/imageSlider/40-3-min.JPG";
import Images52 from "../../../../../assets/img/imageSlider/40-4-min.JPG";
import Images53 from "../../../../../assets/img/imageSlider/40-5-min.JPG";
import Images54 from "../../../../../assets/img/imageSlider/40-6-min.JPG";
import Images55 from "../../../../../assets/img/imageSlider/40-7-min.JPG";
import Images56 from "../../../../../assets/img/imageSlider/40-8-min.JPG";
import Images57 from "../../../../../assets/img/imageSlider/40-9-min.JPG";
import Images58 from "../../../../../assets/img/imageSlider/40-10-min.JPG";
import Images59 from "../../../../../assets/img/imageSlider/40-11-min.JPG";
import Images60 from "../../../../../assets/img/imageSlider/40-12-min.JPG";
import Images61 from "../../../../../assets/img/imageSlider/40-13-min.JPG";
import Images62 from "../../../../../assets/img/imageSlider/40-14-min.jpg";
import Images63 from "../../../../../assets/img/imageSlider/40-15-min.jpg";
import Images64 from "../../../../../assets/img/imageSlider/slide-3-min.jpg";
import Images65 from "../../../../../assets/img/imageSlider/40-16-min.JPG";
import Images66 from "../../../../../assets/img/imageSlider/40-16-min.JPG";
import Images67 from "../../../../../assets/img/imageSlider/40-17-min.JPG";
import Images68 from "../../../../../assets/img/imageSlider/41-1-min.jpg";
import Images69 from "../../../../../assets/img/imageSlider/41-2-min.jpg";
import Images70 from "../../../../../assets/img/imageSlider/41-3-min.jpg";
import Images71 from "../../../../../assets/img/imageSlider/slide-1-2-min.jpg";
import Images72 from "../../../../../assets/img/imageSlider/slide-1-3-1-min.jpg";
import Images73 from "../../../../../assets/img/imageSlider/slide-1-3-min.jpg";
import Images74 from "../../../../../assets/img/imageSlider/slide-1-4.png";
import Images75 from "../../../../../assets/img/imageSlider/slide-1-min.jpg";

import LeftArrow from "../../../../../assets/img/imageSlider/left_arrow.png";
import RightArrow from "../../../../../assets/img/imageSlider/right_arrow.png";


const items = [
    {id: 1, image: <img className="video-slider-image" src={Images1}/>},
    {id: 2, image: <img className="video-slider-image" src={Images2}/>},
    {id: 3, image: <img className="video-slider-image" src={Images3}/>},
    {id: 4, image: <img className="video-slider-image" src={Images4}/>},
    {id: 5, image: <img className="video-slider-image" src={Images5}/>},
    {id: 6, image: <img className="video-slider-image" src={Images6}/>},
    {id: 7, image: <img className="video-slider-image" src={Images7}/>},
    {id: 8, image: <img className="video-slider-image" src={Images8}/>},
    {id: 9, image: <img className="video-slider-image" src={Images9}/>},
    {id: 10, image: <img className="video-slider-image" src={Images10}/>},
    {id: 11, image: <img className="video-slider-image" src={Images11}/>},
    {id: 12, image: <img className="video-slider-image" src={Images12}/>},
    {id: 13, image: <img className="video-slider-image" src={Images13}/>},
    {id: 14, image: <img className="video-slider-image" src={Images14}/>},
    {id: 15, image: <img className="video-slider-image" src={Images15}/>},
    {id: 16, image: <img className="video-slider-image" src={Images16}/>},
    {id: 17, image: <img className="video-slider-image" src={Images17}/>},
    {id: 18, image: <img className="video-slider-image" src={Images18}/>},
    {id: 19, image: <img className="video-slider-image" src={Images19}/>},
    {id: 20, image: <img className="video-slider-image" src={Images20}/>},
    {id: 21, image: <img className="video-slider-image" src={Images21}/>},
    {id: 22, image: <img className="video-slider-image" src={Images22}/>},
    {id: 23, image: <img className="video-slider-image" src={Images23}/>},
    {id: 24, image: <img className="video-slider-image" src={Images24}/>},
    {id: 25, image: <img className="video-slider-image" src={Images25}/>},
    {id: 26, image: <img className="video-slider-image" src={Images26}/>},
    {id: 27, image: <img className="video-slider-image" src={Images27}/>},
    {id: 28, image: <img className="video-slider-image" src={Images28}/>},
    {id: 29, image: <img className="video-slider-image" src={Images29}/>},
    {id: 30, image: <img className="video-slider-image" src={Images30}/>},
    {id: 31, image: <img className="video-slider-image" src={Images31}/>},
    {id: 32, image: <img className="video-slider-image" src={Images32}/>},
    {id: 33, image: <img className="video-slider-image" src={Images33}/>},
    {id: 34, image: <img className="video-slider-image" src={Images34}/>},
    {id: 35, image: <img className="video-slider-image" src={Images35}/>},
    {id: 36, image: <img className="video-slider-image" src={Images36}/>},
    {id: 37, image: <img className="video-slider-image" src={Images37}/>},
    {id: 38, image: <img className="video-slider-image" src={Images38}/>},
    {id: 39, image: <img className="video-slider-image" src={Images39}/>},
    {id: 40, image: <img className="video-slider-image" src={Images40}/>},
    {id: 41, image: <img className="video-slider-image" src={Images41}/>},
    {id: 42, image: <img className="video-slider-image" src={Images42}/>},
    {id: 43, image: <img className="video-slider-image" src={Images43}/>},
    {id: 44, image: <img className="video-slider-image" src={Images44}/>},
    {id: 45, image: <img className="video-slider-image" src={Images45}/>},
    {id: 46, image: <img className="video-slider-image" src={Images46}/>},
    {id: 47, image: <img className="video-slider-image" src={Images47}/>},
    {id: 48, image: <img className="video-slider-image" src={Images48}/>},
    {id: 49, image: <img className="video-slider-image" src={Images49}/>},
    {id: 50, image: <img className="video-slider-image" src={Images50}/>},
    {id: 51, image: <img className="video-slider-image" src={Images51}/>},
    {id: 52, image: <img className="video-slider-image" src={Images52}/>},
    {id: 53, image: <img className="video-slider-image" src={Images53}/>},
    {id: 54, image: <img className="video-slider-image" src={Images54}/>},
    {id: 55, image: <img className="video-slider-image" src={Images55}/>},
    {id: 56, image: <img className="video-slider-image" src={Images56}/>},
    {id: 57, image: <img className="video-slider-image" src={Images57}/>},
    {id: 58, image: <img className="video-slider-image" src={Images58}/>},
    {id: 59, image: <img className="video-slider-image" src={Images59}/>},
    {id: 60, image: <img className="video-slider-image" src={Images60}/>},
    {id: 61, image: <img className="video-slider-image" src={Images61}/>},
    {id: 62, image: <img className="video-slider-image" src={Images62}/>},
    {id: 63, image: <img className="video-slider-image" src={Images63}/>},
    {id: 64, image: <img className="video-slider-image" src={Images64}/>},
    {id: 65, image: <img className="video-slider-image" src={Images65}/>},
    {id: 66, image: <img className="video-slider-image" src={Images66}/>},
    {id: 67, image: <img className="video-slider-image" src={Images67}/>},
    {id: 68, image: <img className="video-slider-image" src={Images68}/>},
    {id: 69, image: <img className="video-slider-image" src={Images69}/>},
    {id: 70, image: <img className="video-slider-image" src={Images70}/>},
    {id: 71, image: <img className="video-slider-image" src={Images71}/>},
    {id: 72, image: <img className="video-slider-image" src={Images72}/>},
    {id: 73, image: <img className="video-slider-image" src={Images73}/>},
    {id: 74, image: <img className="video-slider-image" src={Images74}/>},
    {id: 75, image: <img className="video-slider-image" src={Images75}/>}


];

class Gallery extends React.Component {
    constructor(props) {
        super(props);
        this.onSlideChange = this.onSlideChange.bind(this);
        this.galleryItems = this.galleryItems.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onPrevClick = this.onPrevClick.bind(this);
    }


    onSlideChange = (e) => {

    };

    galleryItems = () => {
        return (
            items.map((item) => (
                <div key={`key-${item.id}`}>{item.image}</div>
            ))
        )
    };
    onNextClick = () => {
        document.getElementsByClassName("alice-carousel__next-btn-item")[0].click();

    };
    onPrevClick = () => {
        document.getElementsByClassName("alice-carousel__prev-btn-item")[0].click();
    };

    render() {
        const items = this.galleryItems();

       let stagePadding = {
            paddingLeft: 0,
            paddingRight: 0
        };

       let responsive = {
            0: {items: 1},
            600: {items: 2},
            1024: {items: 4},
            2048: {items: 4}
        };
        return (
            <div className="carousel-div" onAnimationIteration={() => this.onNextClick()}>
                <div className="col-md-1  arrow-div text-right">
                    <span onClick={this.onPrevClick}>
                        {/*<a className="previous color-black-hover round a-slide left-slider">&#8249;</a>*/}
                        <img src={LeftArrow} className="bottom-slider-resp" alt="<"/>
                    </span>
                </div>
                <div className="col-md-10 video-align">
                    <AliceCarousel
                        items={items}
                        duration={400}
                        autoPlay={true}
                        // autoPlay={false}
                        startIndex={1}
                        fadeOutAnimation={true}
                        mouseDragEnabled={false}
                        playButtonEnabled={false}
                        autoPlayInterval={2000}
                        autoPlayDirection="ltr"
                        responsive={responsive}
                        disableAutoPlayOnAction={true}
                        onSlideChange={this.onSlideChange}
                        onSlideChanged={this.onSlideChanged}
                        dotsDisabled={true}
                        stagePadding={stagePadding}
                    />
                </div>
                <div className="col-md-1  arrow-div">
                    <span onClick={this.onNextClick} className="arrow-span">
                        {/*<a className="next2 color-black-hover round a-slide right-slider">&#8250;</a>*/}
                         <img src={RightArrow} className="bottom-slider-resp" alt=">"/>
                    </span>
                </div>
            </div>

        );
    }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/VideoSlider/Slider/Slider.js